module.exports = __webpack_public_path__ + "static/media/PaperIcon.3f9762f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/PaperIcon.png
// module id = 1793
// module chunks = 0